export const endpoint = '/portal/v2.0/notification';
export const endpointSubscriptionTypes = '/portal/v2.0/NotificationService/GetSubscriptionTypes';
